import { Component, Input } from '@angular/core'

@Component({
  selector: 'inscricoes-listagem-examinadores-icone-notificar',
  templateUrl: './listagem-examinadores-icone-notificar.component.html',
  styleUrls: ['./listagem-examinadores-icone-notificar.component.scss'],
})
export class ListagemExaminadoresIconeNotificarComponent {
  @Input() isNotificado: boolean = false
  @Input() notificadoAt: Date | null = null
  @Input() isNotificacaoVisualizada: boolean = false
  @Input() notificacaoVisualizadaAt: Date | null = null
}
